import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';

import DashboardLayout from 'layout/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'component/Navbars/DashboardNavbar';

import LoadingScreen from 'component/LoadingScreen';

import DataTable from './DataTable';

// import { useUsers } from 'api/admin/getUsers';
import { useUsers } from './useUsers';

import mongoIdToDt from 'utils/mongoIdToDt';
import { Backdrop, Box, CircularProgress, Icon, Tooltip, Typography } from '@mui/material';
import ArgonButton from 'component/Argon/ArgonButton';
import { format, parse, subDays } from 'date-fns';
import { th } from 'date-fns/locale';
import { useQuery } from '@tanstack/react-query';
import useCredentials from 'api/hook/useCredentials';
import { baseAxios, handleError } from 'api';
// import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from 'react-table';
import { API_URL } from 'utils';

const DC = { '3m': 0, '6m': 0, '1y': 0, '15m': 0 };

// const columns = [
//   {
//     Header: 'อีเมล',
//     Cell: ({ row }) => <Link to={`/admin/user/${row.original._id}`}>{row.original.email}</Link>,
//     accessor: 'email',
//   },
//   {
//     Header: 'บริษัท',
//     Cell: ({ row }) => row.original?.contact?.company || '',
//     accessor: 'contact.company',
//   },
//   {
//     Header: 'วันที่เข้าร่วม',
//     Cell: ({ row }) => mongoIdToDt(row.original._id),
//   },
//   {
//     Header: 'รายละเอียด',
//     Cell: ({ row }) => (
//       <ArgonBox display="flex" alignItems="center">
//         <ArgonBox ml={2}>
//           <Tooltip title="ต่อไป" placement="left">
//             <Link to={`/admin/user/${row.original._id}`}>
//               <ArgonButton variant="outlined" color="success" size="small" iconOnly circular>
//                 <Icon sx={{ fontWeight: 'bold' }}>navigate_next</Icon>
//               </ArgonButton>
//             </Link>
//           </Tooltip>
//         </ArgonBox>
//       </ArgonBox>
//     ),
//   },
// ];

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

const curDate = new Date();

const AdminUsers = () => {
  // const { data: rows, isLoading } = useUsers();
  // const { users: rows, handleSetUsers } = useUsers();
  const authAxios = useCredentials();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const [sorting, setSorting] = useState([{ id: 'createAt', desc: true }]);

  // const [startDate, setStartDate] = useState(subDays(curDate, 30));
  // const [endDate, setEndDate] = useState(curDate);
  // const [openMenu, setOpenMenu] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [input, setInput] = useState('');
  const [keyword, setKeyword] = useState('');

  const dataQuery = useQuery({
    queryKey: ['users', `${pagination.pageIndex}/${pagination.pageSize}`, keyword],
    queryFn: async () => {
      const params = new URLSearchParams({
        keyword,
        ...pagination,
        ...sorting[0],
      });
      return authAxios
        .get(`${API_URL}/admin/user?${params.toString()}`)
        .then((res) => {
          // console.log(res.data);
          return res.data;
        })
        .catch(console.error);
      // return baseAxios(authAxios, {
      //   // url: 'admin/user',
      //   url: `admin/user?${params.toString()}`,
      // });
    },
    // onError: handleError,
    initialData: {
      rows: [],
      pageCount: 0,
      rowCount: 0,
    },
  });

  // const table = useTable({
  //   data: dataQuery.data.rows,
  //   columns,
  //   rowCount: dataQuery.data.rowCount,
  //   getCoreRowModel: getCoreRowModel(),
  //   getPaginationRowModel: getPaginationRowModel(),
  //   onPaginationChange: setPagination,
  //   manualPagination: true,
  //   state: {
  //     pagination,
  //     sorting,
  //   },
  //   getSortedRowModel: getSortedRowModel(),
  //   onSortingChange: setSorting,
  //   debugTable: true,
  // });

  // const table = useTable(
  //   { columns, data: [], initialState: { pageIndex: 0 } },
  //   useGlobalFilter,
  //   useSortBy,
  //   usePagination
  // );

  function handleExport() {
    // console.log(rows);
    const rows = dataQuery.data.rows;
    const curDate = new Date();
    const reports = [];
    for (let i = 0; i < rows.length; i++) {
      const user = rows[i];
      const contact = user.contact;
      const discount = user?.discount || {
        ...DC,
      };
      reports.push({
        _id: user._id,
        email: user.email,
        joinDate: format(parse(mongoIdToDt(user._id), 'dd/MM/yyyy HH:mm:ss', curDate, { locale: th }), 'MMM/dd/yyyy'),
        ...contact,
        'discount.3m': discount?.['3m']?.toString() || '',
        'discount.6m': discount?.['6m']?.toString() || '',
        'discount.1y': discount?.['1y']?.toString() || '',
        'discount.15m': discount?.['15m']?.toString() || '',
      });
    }
    const ws = XLSX.utils.json_to_sheet(reports);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, 'report' + fileExtension);
  }

  // return (
  //   <Box>
  //     <Typography>{`${dataQuery.data?.rows?.length}`}</Typography>
  //   </Box>
  // );

  if (dataQuery.isLoading) {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <LoadingScreen>
      <DashboardLayout bgColor="success">
        <DashboardNavbar />
        <ArgonBox py={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <ArgonBox>
                <Card>
                  <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
                    <ArgonBox lineHeight={1}>
                      <ArgonTypography variant="h5" fontWeight="medium">
                        การจัดการสมาชิก
                      </ArgonTypography>
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonButton variant="gradient" color="info" size="small" onClick={handleExport}>
                        ส่งออก
                      </ArgonButton>
                    </ArgonBox>
                  </ArgonBox>
                  <ArgonBox px={3}>
                    <DataTable
                      table={{
                        columns: [
                          {
                            Header: 'อีเมล',
                            Cell: ({ row }) => <Link to={`/admin/user/${row.original._id}`}>{row.original.email}</Link>,
                            accessor: 'email',
                          },
                          {
                            Header: 'บริษัท',
                            Cell: ({ row }) => row.original?.contact?.company || '',
                            accessor: 'contact.company',
                          },
                          {
                            Header: 'วันที่เข้าร่วม',
                            Cell: ({ row }) => mongoIdToDt(row.original._id),
                          },
                          {
                            Header: 'รายละเอียด',
                            Cell: ({ row }) => (
                              <ArgonBox display="flex" alignItems="center">
                                <ArgonBox ml={2}>
                                  <Tooltip title="ต่อไป" placement="left">
                                    <Link to={`/admin/user/${row.original._id}`}>
                                      <ArgonButton variant="outlined" color="success" size="small" iconOnly circular>
                                        <Icon sx={{ fontWeight: 'bold' }}>navigate_next</Icon>
                                      </ArgonButton>
                                    </Link>
                                  </Tooltip>
                                </ArgonBox>
                              </ArgonBox>
                            ),
                          },
                        ],
                        rows: dataQuery.data.rows,
                      }}
                      data={dataQuery.data}
                      // useGlobalFilter={useGlobalFilter}
                      // useSortBy={useSortBy}
                      // usePagination={usePagination}
                      pagination={pagination}
                      setPagination={setPagination}
                      keyword={keyword}
                      setKeyword={setKeyword}
                      entriesPerPage={{
                        defaultValue: pagination.pageSize,
                        entries: [10, 25, 50, 100],
                      }}
                      canSearch
                    />
                  </ArgonBox>
                </Card>
              </ArgonBox>
            </Grid>
          </Grid>
        </ArgonBox>
      </DashboardLayout>
    </LoadingScreen>
  );
};

export default AdminUsers;
